import {Modal as BootstrapModal, ModalBody, ModalHeader} from 'reactstrap'
import {toastr} from 'react-redux-toastr'

import SubmitButton from '../../Forms/LanguageForm/SubmitButton.jsx'
import Modal from "../Modal.jsx"
import LanguageForm from "../../Forms/LanguageForm/LanguageForm.jsx"

export default class LanguageModal extends Modal {
  onSubmitSuccess = () => {
    const action = (this.props.offset !== undefined) ?
      'modifiée' : 'créée'
    toastr.success(`La langue a été ${action} avec succès.`)
  }

  onSubmit = (values) => {
    const {freelance} = this.props
    const languages = this.props.freelance?.languages?.length ? this.props.freelance.languages : []
    const languageId = values.language[0]?.id
    const languageName = values.language[0]?.name
    const newLanguage = {level: values.level, language: languageId, name: languageName}

    languages.push(newLanguage)

    if (this.props.onSubmit) {
      this.props.onSubmit({freelance: {...freelance, languages}})
    }

    if (this.props.onClose) {
      this.props.onClose(languages)
    }

    this.props.closeModal()
  }

  render() {
    if (!this.props.freelance) {
      return null
    }

    const languages = (this.props.offset !== undefined && this.props.freelance.languages[this.props.offset]) || null

    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} className="mission-modal modal-lg">
        <ModalHeader toggle={this.props.closeModal}>Langues</ModalHeader>
        <ModalBody>
          <LanguageForm
            onSubmitSuccess={this.onSubmitSuccess}
            initialValues={languages}
            onSubmit={this.onSubmit}
          />
          <div className="text-center">
            <SubmitButton className="btn btn-primary my-3">
              Enregistrer
            </SubmitButton>
          </div>
        </ModalBody>
      </BootstrapModal>
    )
  }
}
